import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-mb-0 p-ml-2" }
const _hoisted_2 = { class: "p-error" }
const _hoisted_3 = { class: "p-mt-2" }
const _hoisted_4 = { class: "p-d-flex p-flex-wrap p-justify-between p-mt-3" }
const _hoisted_5 = { class: "p-d-flex p-justify-center" }
const _hoisted_6 = { id: "print-ticket" }
const _hoisted_7 = {
  class: "table-content",
  border: "1",
  cellspacing: "0",
  cellpadding: "4"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("td", null, "Coca Cola", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("td", null, "10", -1)
const _hoisted_10 = { colspan: "2" }
const _hoisted_11 = { colspan: "2" }
const _hoisted_12 = { class: "p-d-flex p-flex-wrap p-mt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Button = _resolveComponent("Button")!
  const _component_NumberFormatter = _resolveComponent("NumberFormatter")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Divider, { align: "center" }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, [
          _createVNode(_component_Checkbox, {
            binary: true,
            "true-value": 1,
            "false-value": 0,
            "model-value": _ctx.margeActive,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:margeActive', $event)))
          }, null, 8, ["model-value"]),
          _createElementVNode("label", _hoisted_1, _toDisplayString(_ctx.$t("terminal.margins")) + " [" + _toDisplayString(_ctx.$t(_ctx.marginsState)) + "] ", 1)
        ])
      ]),
      _: 1
    }),
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t("terminal.warningMarge")), 1),
    _createElementVNode("div", _hoisted_3, " [" + _toDisplayString(_ctx.$t("terminal.top")) + ", " + _toDisplayString(_ctx.$t("terminal.right")) + ", " + _toDisplayString(_ctx.$t("terminal.bottom")) + ", " + _toDisplayString(_ctx.$t("terminal.left")) + "] : " + _toDisplayString(_ctx.convertMargins(_ctx.modelValue)), 1),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_Button, {
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.visible = true)),
        "icon-pos": "right",
        icon: "pi pi-pencil",
        class: "p-button-success p-button-outlined p-button-rounded",
        label: _ctx.$t('terminal.customize')
      }, null, 8, ["label"]),
      _createVNode(_component_Button, {
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.restoreMargins())),
        class: "p-button-text p-mb-0",
        label: _ctx.$t('terminal.reset')
      }, null, 8, ["label"])
    ]),
    (_ctx.visible)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 0,
          header: _ctx.$t('terminal.customizeTitle'),
          visible: _ctx.visible,
          "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
          style: {"max-width":"85%","width":"520px"}
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "p-button-success",
              icon: "pi pi-save",
              label: _ctx.$t('terminal.apply'),
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.applyMargins()))
            }, null, 8, ["label"]),
            _createVNode(_component_Button, {
              icon: "pi pi-print",
              "icon-pos": "right",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.printElement('print-ticket', _ctx.convertMargins(_ctx.marginValues)))),
              label: _ctx.$t('terminal.test')
            }, null, 8, ["label"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", {
                class: "p-mx-1",
                style: _normalizeStyle([{ padding: _ctx.convertMargins(_ctx.marginValues) }, {"border":"1px solid gainsboro","width":"100%","height":"15rem"}])
              }, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("table", _hoisted_7, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("stock.product")), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("payment.quantity")), 1),
                        _createElementVNode("td", null, _toDisplayString(_ctx.$t("payment.total")), 1)
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      _createElementVNode("tr", null, [
                        _hoisted_8,
                        _hoisted_9,
                        _createElementVNode("td", null, [
                          _createVNode(_component_NumberFormatter, { value: 10000 }),
                          _createTextVNode(" " + _toDisplayString(_ctx.currencySymbol), 1)
                        ])
                      ])
                    ]),
                    _createElementVNode("tfoot", null, [
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_10, _toDisplayString(_ctx.$t("payment.discount")) + " 0 % ", 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_NumberFormatter, { value: 100000 }),
                          _createTextVNode(" " + _toDisplayString(_ctx.currencySymbol), 1)
                        ])
                      ]),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_11, _toDisplayString(_ctx.$t("payment.ttcTotal")), 1),
                        _createElementVNode("td", null, [
                          _createVNode(_component_NumberFormatter, { value: 100000 }),
                          _createTextVNode(" " + _toDisplayString(_ctx.currencySymbol), 1)
                        ])
                      ])
                    ])
                  ])
                ])
              ], 4)
            ]),
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.margins, (mar, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "p-field p-m-1"
                }, [
                  _createElementVNode("div", null, _toDisplayString(_ctx.$t(`terminal.${mar}`)), 1),
                  _createVNode(_component_InputNumber, {
                    "show-buttons": "",
                    "allow-empty": false,
                    step: 1,
                    modelValue: _ctx.marginValues[index],
                    "onUpdate:modelValue": ($event: any) => ((_ctx.marginValues[index]) = $event)
                  }, null, 8, ["modelValue", "onUpdate:modelValue"])
                ]))
              }), 128))
            ]),
            _createVNode(_component_Divider)
          ]),
          _: 1
        }, 8, ["header", "visible"]))
      : _createCommentVNode("", true)
  ], 64))
}